export interface SocialAccount {
  icon: "wechat" | "xiaohongshu" | "bilibili" | "zhihu";
  label: string;
}

function parseSocialAccounts(raw: string): SocialAccount[] {
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (item): item is SocialAccount =>
        typeof item === "object" &&
        item !== null &&
        "icon" in item &&
        "label" in item &&
        typeof (item as { icon: unknown }).icon === "string" &&
        typeof (item as { label: unknown }).label === "string",
    );
  } catch {
    return [];
  }
}

function parseXianyuMap(raw: string): Record<string, string> {
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (parsed === null || typeof parsed !== "object") return {};
    const out: Record<string, string> = {};
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof v === "string") out[k] = v;
    }
    return out;
  } catch {
    return {};
  }
}

function toWechatProfileUrl(followUrl: string): string {
  try {
    const url = new URL(followUrl);
    const biz = url.searchParams.get("__biz");
    if (biz?.startsWith("gh_")) return `weixin://contacts/profile/${biz}`;
  } catch {
    // Keep the configured value for non-URL schemes or malformed dev values.
  }
  return followUrl;
}

const wechatFollowUrl =
  import.meta.env.VITE_WECHAT_FOLLOW_URL ??
  "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=PLACEHOLDER";

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  brandName: import.meta.env.VITE_BRAND_NAME ?? "晴和日语",
  shortLink: import.meta.env.VITE_SHORT_LINK ?? "seiwa.app/d",
  socialAccounts: parseSocialAccounts(import.meta.env.VITE_SOCIAL_ACCOUNTS ?? "[]"),
  wechatFollowUrl,
  wechatProfileUrl: toWechatProfileUrl(wechatFollowUrl),
  xianyuUrlByPack: parseXianyuMap(import.meta.env.VITE_XIANYU_URL_BY_PACK ?? "{}"),
  // Toggle custom Japanese webfont (M PLUS Rounded 1c). When false, the app
  // falls back to the system stack defined in tokens.css `--font-sans`.
  // To enable: set VITE_USE_CUSTOM_FONTS=true and uncomment the preload
  // <link> tags in index.html.
  useCustomFonts: import.meta.env.VITE_USE_CUSTOM_FONTS === "true",
} as const;
